import React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';

const MyGroups = ({ groups }) => {

    const groupStatuses = [
        {
            id: 1,
            status: 'Active',
            label: 'Active'
        }
    ]

    const groupsToDisplay = groupStatuses.map(x=> 
        <TileGroup  
            key={x.id}
            groupBy={x.label} 
            elements={groups.filter(group => (group.siteStatus === x.status)).map(s =>
                <SingleSite
                    key={s.id}
                    site={s}
                />)}
        />)

    return(
        <div>
            <MessageBar messageBarType={MessageBarType.info}>
                <span>
                    This view shows only Microsoft 365 Groups that contain at least 1 stored file. Empty Groups are not displayed. To view and manage all your Groups - including removing unused ones, managing access - click<a href="https://myaccount.microsoft.com/groups/groups-i-own" target="_blank" rel="noopener noreferrer">here</a>.
                </span>
            </MessageBar>

            {groupsToDisplay}
        </div>
    );
}

export default MyGroups


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyGroups.js